/**
 * Skeleton primitives — shimmer animation on glassmorphism dark theme.
 */

export const Skeleton = ({ className = "", ...props }) => (
  <div
    className={`relative overflow-hidden bg-white/5 rounded ${className}`}
    aria-hidden="true"
    {...props}
  >
    <div className="absolute inset-0 -translate-x-full animate-skeleton-shimmer bg-gradient-to-r from-transparent via-white/10 to-transparent" />
  </div>
);

// Pre-built blocks (Account / Health / List)

export const SkeletonHealthCard = () => (
  <div className="bg-white/10 backdrop-blur-sm rounded-2xl border border-white/10 p-6 mb-6">
    <div className="flex items-center gap-5">
      <Skeleton className="w-24 h-24 rounded-full" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-3 w-28 rounded-full" />
        <Skeleton className="h-4 w-56 rounded" />
        <Skeleton className="h-3 w-72 rounded" />
      </div>
    </div>
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 mt-6">
      {[0, 1, 2, 3].map((i) => (
        <div key={i} className="bg-white/5 border border-white/10 rounded-2xl p-4 space-y-2">
          <Skeleton className="h-3 w-20 rounded-full" />
          <Skeleton className="h-7 w-24 rounded" />
          <Skeleton className="h-2.5 w-16 rounded-full" />
        </div>
      ))}
    </div>
  </div>
);

export const SkeletonAccountCard = () => (
  <div className="bg-white/10 backdrop-blur-sm rounded-2xl border border-white/10 p-6 mb-6 space-y-4">
    <div className="flex items-start justify-between">
      <div className="space-y-2">
        <Skeleton className="h-4 w-32 rounded" />
        <Skeleton className="h-5 w-20 rounded-full" />
      </div>
      <Skeleton className="h-8 w-24 rounded" />
    </div>
    <div className="grid sm:grid-cols-3 gap-4">
      {[0, 1, 2].map((i) => (
        <div key={i} className="space-y-2">
          <Skeleton className="h-2.5 w-16 rounded-full" />
          <Skeleton className="h-4 w-28 rounded" />
        </div>
      ))}
    </div>
    <Skeleton className="h-11 w-full rounded-xl" />
  </div>
);

export const SkeletonList = ({ rows = 3 }) => (
  <div className="space-y-3">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="flex items-center justify-between py-3 border-b border-white/10">
        <div className="space-y-2">
          <Skeleton className="h-4 w-40 rounded" />
          <Skeleton className="h-3 w-24 rounded-full" />
        </div>
        <div className="space-y-2 text-right">
          <Skeleton className="h-4 w-16 rounded ml-auto" />
          <Skeleton className="h-3 w-12 rounded-full ml-auto" />
        </div>
      </div>
    ))}
  </div>
);

export const SkeletonKPIGrid = () => (
  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
    {[0, 1, 2].map((i) => (
      <div key={i} className="bg-white/10 border border-white/10 rounded-2xl p-5 space-y-3">
        <Skeleton className="h-3 w-24 rounded-full" />
        <Skeleton className="h-8 w-32 rounded" />
        <Skeleton className="h-2.5 w-20 rounded-full" />
      </div>
    ))}
  </div>
);
